module.exports = __webpack_public_path__ + "img/76.3ab10fa2.jpg";